import { useEffect, useState } from "react";
import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL; 

/**
 * 로그 저장 함수
 * @param {string} userId - 사용자 ID
 * @param {string} dateTime - 현재 시간 (ISO 형식 추천)
 * @param {string} userIP - 사용자 IP
 * @param {string} userObject - 로그와 관련된 객체
 * @param {string} content - 로그 내용
 */

const AddLog = async (userId, userIP, userObject, content) => {

    // ✅ 현재 날짜 및 시간 가져오기 (YY-MM-DD HH:mm 형식)
    const now = new Date();
    now.setHours(now.getHours() + 9); // UTC+9 적용

    const dateTime = now.toISOString().slice(2, 16).replace("T", " ");

    
    try {

        const response = await axios.post(`${API_BASE_URL}/api/Log/add-log`, {
            UserId: userId,           // ✅ 서버에서 기대하는 대문자 변수명 사용
            DateTime: dateTime,       // ✅ 서버에서 기대하는 대문자 변수명 사용
            UserIP: userIP,           // ✅ 서버에서 기대하는 대문자 변수명 사용
            UserObject: userObject,   // ✅ 서버에서 기대하는 대문자 변수명 사용
            UserContent: content      // ✅ 서버에서 기대하는 대문자 변수명 사용
        });

        //로그 저장 성공:", response.data);
        return response.data; // 성공 시 결과 반환
    } catch (error) {
        if (error.response) {
            //console.error("서버 오류:", error.response.data?.message);
            //alert(error.response.data?.message || "서버 오류");
        } else if (error.request) {
            //console.error("서버 응답 없음");
            //alert("서버에 응답이 없습니다.");
        } else {
            //console.error("요청 오류:", error.message);
            //alert("로그 저장 요청 중 오류 발생");
        }
    }
};

export default AddLog;

